import {
    Box,
    Button,
    Pagination,
    Paper,
    Skeleton,
    Tab,
    Tabs,
    useMediaQuery,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { TableSortLabel } from "@mui/material";
import ReceiptIcon from "@mui/icons-material/Receipt";

import dayjs from "dayjs";
import "dayjs/locale/ru"; // для русского языка
import { useEffect, useLayoutEffect, useMemo, useState } from "react";
import { useMetersStore } from "../../../../store/meters.store";
import {
    Reading,
    ReadingData,
} from "../../../../types/Store/MetersStore.types";
import { MetersNames } from "../../../../configs/meters.config";
import { Loading } from "../../../../utils/components/Loading";
dayjs.locale("ru");

export function MetersHistory() {
    const navigate = useNavigate();
    const { meters, readings, getReadings, getMeters } = useMetersStore();

    const [tabValue, setTabValue] = useState(meters?.[0]?.id || "");

    useEffect(() => {
        (async () => {
            await getMeters();
            await getReadings();
        })();
    }, []);

    const handleChangeTab = (event: any, newValue: string) => {
        setTabValue(newValue);
    };

    if (!readings || !meters) return <Loading />;

    console.log(meters, readings);

    return (
        <Box sx={{

        }}>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "30px",
                }}
            >
                <h1>История показаний</h1>
                <Button
                    variant="contained"
                    onClick={() => navigate("/admin/meters")}
                >
                    Вернуться обратно
                </Button>
            </Box>
            <Paper>
                <Tabs
                    value={tabValue}
                    onChange={handleChangeTab}
                    // aria-label="wrapped label tabs example"
                    scrollButtons={true}
                    variant="scrollable"
                    sx={{
                        maxWidth:"calc(100vw - 48px)"
                    }}
                >
                    {meters.map((n) => {
                        return <Tab value={n.id} label={n.title} key={n.id}/>;
                    })}
                </Tabs>
                {readings.map(
                    (m) =>
                        tabValue == m.meter.id.toString() && (
                            <MetersHistoryTable reading={m} />
                        )
                )}
            </Paper>
        </Box>
    );
}

const MetersHistoryTable = ({ reading }: { reading: Reading }) => {
    const { getReadingOffset } = useMetersStore();
    const [page, setPage] = useState(1);
    const [order, setOrder] = useState<"asc" | "desc">("desc");

    const handleSortDate = () => {
        setOrder((prev) => (prev === "asc" ? "desc" : "asc"));
    };
    const isMobile = useMediaQuery("(max-width:1100px)");


    const [loadingPage, setLoadingPage] = useState(false);

    let [readingData, setReadingData] = useState(reading);
    let [readings, setReadings] = useState(readingData.readings);

    const handleChangePage = async (event: any, page: number) => {
        try {
            setLoadingPage(true);
            setPage(page);
            const newReading = await getReadingOffset(
                reading.meter.id,
                (page - 1) * 10,
                order.toUpperCase()
            );
            setReadingData(newReading);
            setReadings(newReading.readings);
        } catch (error) {
        } finally {
            setLoadingPage(false);
        }
    };

    useEffect(() => {
        handleChangePage(null, page);
    }, [page, order]);

    if (loadingPage)
        return (
            // <Box sx={{
            //     display:"flex",
            //     justifyContent:"center",
            //     marginTop:"70px",
            //     paddingBottom:"70px"
            // }}>
            //     <Loading />
            // </Box>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                <TableContainer 
                sx={{
                    maxWidth: isMobile ? "calc(100vw - 48px)" : "100%",
                    overflowX: "auto",
                }}>
                    <Table aria-label="Таблица истории платежей">
                        <TableHead>
                            <TableRow>
                                <TableCell sortDirection={order} align="left">
                                    <TableSortLabel
                                        active
                                        direction={order}
                                        onClick={handleSortDate}
                                    >
                                        Дата
                                    </TableSortLabel>
                                </TableCell>
                                <TableCell sortDirection={order} align="center">
                                    <TableSortLabel>Показания счетчика</TableSortLabel>
                                </TableCell>
                                <TableCell align="center">Потребление</TableCell>
                                <TableCell align="center"></TableCell>
                                <TableCell />
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {Array(10)
                                .fill(10)
                                .map((n, v) => {
                                    return (
                                        <TableRow key={v}>
                                            <TableCell>
                                                <Skeleton variant="text" width={100}/>
                                            </TableCell>
                                            <TableCell align="center">
                                                <Skeleton variant="text" width={100} sx={{
                                                    marginLeft:"auto",
                                                    marginRight:"auto"
                                                }}/>
                                            </TableCell>
                                            <TableCell align="center">
                                                <Skeleton variant="text" width={100} sx={{
                                                    marginLeft:"auto",
                                                    marginRight:"auto"
                                                }}/>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <Pagination
                    sx={{
                        marginTop: "16px",
                        marginBottom: "16px",
                    }}
                    count={
                        Math.floor(readingData.total_count / 10) +
                        (readingData.total_count % 10 == 0 ? 0 : 1)
                    }
                    disabled
                />
            </Box>
        );

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
            }}
        >
            <TableContainer>
                <Table aria-label="Таблица истории платежей">
                    <TableHead>
                        <TableRow>
                            <TableCell sortDirection={order} align="left">
                                <TableSortLabel
                                    active
                                    direction={order}
                                    onClick={handleSortDate}
                                >
                                    Дата
                                </TableSortLabel>
                            </TableCell>
                            <TableCell sortDirection={order} align="center">
                                <TableSortLabel>Показания счетчика</TableSortLabel>
                            </TableCell>
                            <TableCell align="center">Потребление</TableCell>
                            <TableCell align="center"></TableCell>
                            <TableCell />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {readings.map((row, i) => {
                            let currConsumption: number | string = 0;
                            if (order === "desc") {
                                currConsumption = i < readings.length - 1 ? row.value - readings[i + 1].value : "-";
                            } else {
                                currConsumption = i > 0 ? row.value - readings[i - 1].value : "-";
                            }
                            return (
                                <TableRow key={i}>
                                    <TableCell align="left">
                                        {
                                            dayjs(new Date(row.date))
                                                .format("D MMM, YYYYг.")
                                                .split(",")[0]
                                        }
                                        <span
                                            style={{
                                                color: "#82809c",
                                            }}
                                        >
                                            ,
                                            {
                                                dayjs(new Date(row.date))
                                                    .format("D MMM, YYYYг.")
                                                    .split(",")[1]
                                            }
                                        </span>
                                    </TableCell>
                                    <TableCell align="center">
                                        {row.value} {reading.meter.units || "куб/м"}
                                    </TableCell>
                                    <TableCell align="center">
                                        {currConsumption} {currConsumption !== "-" ? (reading.meter.units || "куб/м") : ""}
                                    </TableCell>
                                    <TableCell />
                                    <TableCell />
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            <Pagination
                sx={{
                    marginTop: "16px",
                    marginBottom: "16px",
                }}
                count={
                    Math.floor(readingData.total_count / 10) +
                    (readingData.total_count % 10 == 0 ? 0 : 1)
                }
                page={page}
                onChange={handleChangePage}
            />
        </Box>
    );
};
